import { type Route } from '@/types/route'

import { getFirstPossibleRoute } from '../utils/getFirstPossibleRoute'

export const artisansAndAdminsTabRoutes = [
  {
    path: 'artisans-list',
    name: 'teacher-list',
    component: () =>
      import('@/views/TeachersAdmin/TeachersList/TeachersListView.vue'),
    meta: {
      icon: 'user',
      title: 'Artisans',
      tab: 'administration',
      permissions: ['permissions.view_teachers_management']
    }
  },
  {
    path: 'users',
    name: 'users-list',
    component: () => import('@/views/TeachersAdmin/UserList/UserListView.vue'),
    meta: {
      icon: 'calendar',
      title: 'All users',
      tab: 'administration',
      permissions: ['permissions.view_users_management']
    }
  }
] satisfies Route[]

export const userViewChildrenRoutes = [
  {
    path: 'details',
    name: 'user-details',
    component: () =>
      import('@/views/TeachersAdmin/UserDetails/UserDetailsView.vue'),
    meta: {
      title: 'Details',
      tab: 'administration',
      permissions: ['users.view_user']
    }
  },
  {
    path: 'edit',
    name: 'user-edit',
    component: () => import('@/views/TeachersAdmin/EditUser/EditUserView.vue'),
    meta: {
      title: 'User edit',
      tab: 'administration',
      permissions: ['users.change_user']
    }
  },
  {
    path: 'custom-schedule',
    name: 'user-custom-schedule',
    component: () => import('@/views/TeachersAdmin/CustomScheduleView.vue'),
    meta: {
      title: 'Artisan custom schedule',
      tab: 'administration',
      permissions: ['teachers.change_teacher']
    }
  }
] satisfies Route[]

export const artisansAndAdminsNotTabRoutes = [
  {
    path: '',
    name: 'artisans-and-admins-tab',
    component: () => import('@/components/base/BaseLayout.vue'),
    props: {
      routes: artisansAndAdminsTabRoutes
    },
    meta: {
      tab: 'administration'
    },
    redirect: () => getFirstPossibleRoute(artisansAndAdminsTabRoutes),
    children: artisansAndAdminsTabRoutes
  },
  {
    path: 'add-user',
    name: 'add-user',
    component: () => import('@/views/TeachersAdmin/AddUser/AddUserView.vue'),
    meta: {
      title: 'User add',
      tab: 'administration',
      permissions: ['users.add_user']
    }
  },
  {
    path: 'users/:userId',
    name: 'user-view',
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      tab: 'administration'
    },
    redirect: () => getFirstPossibleRoute(userViewChildrenRoutes),
    children: userViewChildrenRoutes
  }
] satisfies Route[]

export const artisansAndAdminsRoutes = [
  {
    path: 'artisans',
    name: 'artisans-and-admins',
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      title: 'Artisans & Admins',
      icon: 'team',
      tab: 'administration',
      permissions: [
        'permissions.view_teachers_management',
        'permissions.view_users_management'
      ]
    },
    redirect: () => getFirstPossibleRoute(artisansAndAdminsNotTabRoutes),
    children: artisansAndAdminsNotTabRoutes
  }
] satisfies Route[]
